/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedGeneric() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-generic-intro")}
        {/* We regret to inform you that your recent identification submission has been unsuccessful. The information you provided has been reviewed and unfortunately, we were unable to verify your identity to meet the required standards. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-generic-header")}
        {/* The reasons for this failure may include, but are not limited to: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-1")}
            {" "}
            {/* Incomplete or Inaccurate Information:  */}
          </strong>

          {t("security:kyc-failed-generic-list-item-1")}
          {/* The information you provided was incomplete or contained inaccuracies,
					making it difficult for us to establish your identity conclusively. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-2")}
            {" "}
            {/* Document Quality: */}
          </strong>

          {t("security:kyc-failed-generic-list-item-2")}
          {/* The quality of the documents you submitted, such as your ID card,
					passport etc., did not meet our verification standards. This could
					include issues like low-resolution photograph, illegibility, or
					expired documents. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-3")}
            {" "}
            {/* Mismatched Information: */}
          </strong>

          {t("security:kyc-failed-generic-list-item-3")}
          {/* The details provided in your submission did not match the information
					we have on record or the information provided during your registration
					process. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-4")}
            {" "}
            {/* Suspicious Activity: */}
          </strong>
          {t("security:kyc-failed-generic-list-item-4")}
          {/* Our security protocols have flagged your submission for potential
					irregularities, and further investigation is required. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-generic-instructions")}
        {/* To resolve this issue and complete your verification, we kindly request
				that you take the following steps: */}
        <div class="w-full h-4" />
      </p>
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-5")}
            {/* Review and Update Information: */}
            {" "}
          </strong>
          {t("security:kyc-failed-generic-list-item-5")}
          {/* Please review the information you provided during the process and
					ensure that all details are accurate and up to date. If any
					information has changed, please update it accordingly. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-generic-list-header-6")}
            {/* Submit Clear and Legible Documents: */}
            {" "}
          </strong>
          {t("security:kyc-failed-generic-list-item-6")}
          {/* Ensure that the documents you submit are clear, legible, and meet our
					verification standards. If necessary, provide higher-quality scans or
					photos of your identification documents. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-generic-ending")}
        {/* We look forward to receiving your next submission. */}
      </p>
    </>
  );
}
export default SecurityFailedGeneric;
